// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".virtual-spacer[data-v-f21b8f58]{position:relative;overflow-anchor:none}.virtual-content[data-v-f21b8f58]{position:absolute;top:0;left:0;right:auto;min-width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
